import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/ebay-freight-spring-2022';

export default function Example() {
  return (
    <>
      <Head>
        <title>Guide to eBay Freight Shipping 2022</title>
        <meta
          name='description'
          content='Learn how eBay freight shipping works and see what type of shipping will work best for you'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/ebay-freight-spring-2022' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/ebay-freight-spring-2022' />
        <meta property='og:title' content='Guide to eBay Freight Shipping 2022' />
        <meta
          property='og:description'
          content='Learn how eBay freight shipping works and see what type of shipping will work best for you'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-04-29T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-04-29T00:00:00-00:00' />
        <meta property='article:tag' content='eBay' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
